<script setup>
import {computed} from 'vue'
import UserAvatar from './UserAvatar.vue'
import {useComponentsStore} from '@/stores/components'
import {useUserTrackingStore} from '@/stores/userTracking'

const props = defineProps({
    tableName: String,
    itemId: Number,
})

// Pinia Stores
const componentsStore = useComponentsStore()
const userTrackingStore = useUserTrackingStore()

// --- Computed ---

/**
 * Retrieves the internal Component ID based on the table name.
 */
const componentId = computed(() => {
    return componentsStore.componentIds[props.tableName]
})

/**
 * Resolves the user ID of whoever is currently 'tracking' (viewing/editing)
 * this specific record.
 */
const activeUserId = computed(() => {
    if (!componentId.value || !props.itemId) return null

    // Uses Pinia store checkKeys method
    return userTrackingStore.checkKeys({
        componentId: componentId.value,
        itemId: props.itemId
    })
})
</script>

<template>
    <UserAvatar
        v-if="activeUserId"
        :user-id="activeUserId"
        :tooltip-placement="'right'"
        :is-small="true"
        class="user-tracking-avatar"
    />
</template>

<style scoped>
/* Table View Positioning */
.table-view .user-tracking-avatar {
    position: absolute;
    right: 5px;
}

/* List view Positioning */
.list-view .user-tracking-avatar {
    position: absolute;
    left: -10px;
    top: 10px;
}

/* Sidebar/Nav Positioning */
.themes-editor-nav-link .user-tracking-avatar {
    margin-left: -10px;
}
</style>